var stringify = require("./json-stringify-safe");

$.fn.freeTextSearch = function () {
  var $self = $(this);
  var $submit = $self.next(".govuk-button");
  var $body = $self.closest(".govuk-main-wrapper");

  var _state = {
    id: "freetext",
    type: "freetext",
    model: [{ id: "freetext", label: "freetext", value: $self.val()}],
    activeFacet: false,
    initialValue: $self.val()
  };

  // handle enter event and stop form from posting
  $self.keydown(function (event) {
    //allow the 'Apply filters' button to activate as soon as you start writing something in the text field
    $('.apply-all-filters').attr('disabled', false)
      .attr('aria-disabled', false);

    if (event.keyCode == 13) {
      event.preventDefault();
      _clickEvent();
      return false;
    }
  });

  $self.on("search", function (e) {
    _clickEvent();
  });

  $submit.on("click", _clickEvent);

  function _clickEvent(event) {
    _setModelItem();
    _triggerDclgFacetsChanged(JSON.parse(stringify(_state)));
  }

  $self.on("dclg.facets.reset", function (e) {
    $self.val(_state.initialValue);
    _setModelItem();
  });

  function _triggerDclgFacetsChanged(obj) {
    $body.trigger("dclg.facets.changed", obj);
  }

  function _setModelItem() {
    _state.model[0].value = $self.val();
  }
};
